import React from 'react'
import { PropTypes } from 'prop-types'
import styled from 'styled-components'
import NavigationLink from '../NavigationLink/NavigationLink'

const Container = styled.ul`
  margin-top: 24px;
  padding-left: 0;
  list-style-type: none;
`

const Separator = styled.li`
  border-top: 1px solid rgba(242, 246, 249, 0.3);
  margin: 12px 0;
`

const NavigationContainer = ({ links }) => (
  <Container>
    {links?.map((link) => (
      <React.Fragment key={link.href}>
        <NavigationLink role="presentation" link={link} />
        {link.separatorAfter ? <Separator role="separator" /> : null}
      </React.Fragment>
    ))}
  </Container>
)

NavigationContainer.propTypes = {
  links: PropTypes.array.isRequired,
}

export default NavigationContainer
